import { useMutation, useQueryClient } from "@tanstack/react-query";
import { putTestMode } from "../api/mobility";
import { useSnackbar } from "notistack";

const usePutTestMode = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: putTestMode,
    onSuccess: (data) => {
      enqueueSnackbar(data.message, {
        variant: "success",
      });
      queryClient.invalidateQueries({ queryKey: ["Mobility"] });
    },
  });

  return mutation;
};

export default usePutTestMode;
